export const ETA_TIME_UNIT = 'min';
export const MAP_MARKER_TYPES = {
  PICKUP: 'PICKUP',
  DROP_OFF: 'DROP_OFF',
  VEHICLE: 'VEHICLE',
};
